import { useEffect, useRef, useState } from "react";
import { requestAudioPlay, releaseAudio } from "./audioManager";

export default function InstructionAudioButton({ src, label = "Play audio" }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    return () => {
      const audio = audioRef.current;
      if (!audio) return;
      audio.pause();
      releaseAudio(audio);
    };
  }, []);

  if (!src) return null;

  async function toggleAudio(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    const audio = audioRef.current;
    if (!audio) return;

    if (!audio.paused) {
      audio.pause();
      return;
    }

    requestAudioPlay(audio);

    try {
      await audio.play();
    } catch {
      releaseAudio(audio);
      setPlaying(false);
    }
  }

  return (
    <>
      <audio
        ref={audioRef}
        src={src}
        preload="none"
        onPlay={() => setPlaying(true)}
        onPause={() => {
          setPlaying(false);
          releaseAudio(audioRef.current);
        }}
        onEnded={() => {
          setPlaying(false);
          releaseAudio(audioRef.current);
        }}
      />

      <button
        type="button"
        onClick={toggleAudio}
        aria-label={label}
        title={label}
        style={{
          width: 28,
          height: 28,
          padding: 0,
          border: "1px solid #bbb",
          borderRadius: "50%",
          background: playing ? "#eef5ff" : "#fff",
          display: "inline-grid",
          placeItems: "center",
          cursor: "pointer",
          flex: "0 0 auto"
        }}
      >
        {playing ? (
          <svg width="13" height="13" viewBox="0 0 13 13" aria-hidden="true">
            <rect x="2" y="2" width="3" height="9" rx="0.6" fill="currentColor" />
            <rect x="8" y="2" width="3" height="9" rx="0.6" fill="currentColor" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M4 9v6h4l5 4V5L8 9H4Zm12.5 3a4.5 4.5 0 0 0-2-3.74v7.48A4.5 4.5 0 0 0 16.5 12Zm-2-8.31v2.06a7 7 0 0 1 0 12.5v2.06a9 9 0 0 0 0-16.62Z"
              fill="currentColor"
            />
          </svg>
        )}
      </button>
    </>
  );
}
